import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { isPlainLeftClick } from '../../utils/isPlainLeftClick';

type Props = {
  backLink?: string;
  htmlTitle?: string;
};

export function useFullPageLayout(props: Props) {
  const navigate = useNavigate();

  useDocumentTitle(props.htmlTitle);

  function handleBackClick(event: MouseEvent<HTMLElement>) {
    if (!props.backLink || !isPlainLeftClick(event)) {
      return;
    }
    event.preventDefault();
    navigate(props.backLink);
  }

  return { handleBackClick };
}
